import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ChatAssistant from './components/ChatAssistant';
import Home from './pages/Home';
import Login from './pages/Login';
import Overview from './pages/Overview';
import DeviceDetail from './components/DeviceDetail';
import MQTTClient from './components/MQTTClient';
import ImageGallery from './components/ImageGallery';
import ScrollToTop from './components/ScrollToTop';
import BluetoothConnect from './components/BluetoothConnect';
import { fetchOnlineCount } from './components/DataHandler';
import './index.css';

function App() {
  const [mqttMessage, setMqttMessage] = useState<string>('');
  const [connectionCount, setConnectionCount] = useState<number>(0);

  // ✅ 백엔드에서 실시간 온라인 기기 수 가져오기 (5초마다 갱신)
  useEffect(() => {
    const getCount = async () => {
      const count = await fetchOnlineCount();
      setConnectionCount(count);
    };

    getCount(); // 초기 실행
    const interval = setInterval(getCount, 5000); // 5초 주기

    return () => clearInterval(interval);
  }, []);

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ScrollToTop />
      <Navbar />
      <MQTTClient onMessage={setMqttMessage} />
      <Routes>
        <Route path="/" element={<Home connectionCount={connectionCount} />} />
        <Route path="/login" element={<Login />} />
        <Route path="/overview" element={<Overview mqttMessage={mqttMessage} />} />
        <Route path="/device/:mac" element={<DeviceDetail mqttMessage={mqttMessage} />} />
        <Route path="/products" element={<div className="section"><div className="container"><ImageGallery /></div></div>} />
        <Route path="/ble" element={<div className="section"><div className="container"><BluetoothConnect /></div></div>} />

        {/* Add other routes as needed */}
      </Routes>
      <Footer />
      <ChatAssistant />
    </Router>
  );
}

export default App;
